import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled, { getSize } from '@xstyled/styled-components';
import React from 'react';
import { styleVariables } from '../../style';
import { jsx as _jsx } from "react/jsx-runtime";
export var STATUS_SUBMISSION = {
  SUBMITTED: '3',
  BANNED: '4',
  DONE: '9',
  NOT_COMPLETED: '8'
};
export var getColorBySubmissionStatus = function getColorBySubmissionStatus(statusType) {
  switch (statusType) {
    case STATUS_SUBMISSION.BANNED:
      return "color: ".concat(styleVariables.colors.red3, "; background: ").concat(styleVariables.colors.red1, "; border: 1px solid ").concat(styleVariables.colors.red3, ";");

    case STATUS_SUBMISSION.DONE:
      return "color: ".concat(styleVariables.colors.colorSuccessBase, "; background: ").concat(styleVariables.colors.colorSuccessBg, "; border: 1px solid ").concat(styleVariables.colors.colorSuccessBase, ";");

    default:
      return "color: ".concat(styleVariables.colors.gray10, "; background: ").concat(styleVariables.colors.gray3, "; border: 1px solid ").concat(styleVariables.colors.gray10, ";");
  }
};
var StyledSubmissionStatusComponent = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 1px 8px;\n  ", ";\n  width: fit-content;\n  border-radius: ", ";\n  display: block;\n  text-align: center;\n  font-size: ", ";\n"])), function (_ref) {
  var statusType = _ref.statusType;
  return getColorBySubmissionStatus(statusType);
}, getSize('radiusSm'), getSize('typo12'));
export var SubmissionStatusComponent = function SubmissionStatusComponent(_ref2) {
  var statusType = _ref2.statusType,
      text = _ref2.text,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100px' : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '22px' : _ref2$height,
      style = _ref2.style,
      className = _ref2.className;
  return /*#__PURE__*/_jsx(StyledSubmissionStatusComponent, {
    statusType: statusType,
    width: width,
    height: height,
    style: style,
    className: className,
    children: text
  });
};